import { Controller } from "@hotwired/stimulus"

// Adds/removes repeatable rows (e.g. dining venues, nightlife clubs) in admin forms.
// A <template data-nested-form-target="template"> holds the blank row markup.
export default class extends Controller {
  static targets = ["list", "template"]

  add(event) {
    event.preventDefault()
    const fragment = this.templateTarget.content.cloneNode(true)
    this.listTarget.appendChild(fragment)
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-nested-row]").remove()
  }
}
